import React from "react";
import { makeStyles } from "@mui/styles";
import { FormLogin } from "../components/login/FormLogin";

export const Login = () => {

    const styles = useStyles();

    return (
        <div className={ styles.screen }>
            <FormLogin />
        </div>
    );
};

const useStyles = makeStyles({
    screen: {
        display: 'flex',
    }
});